import { createAsyncThunk } from '@reduxjs/toolkit';

import type { CreatePendenciaInput, InternalChatPendencia } from '../../types';
import { pendenciasService } from './services';

const reject = (error: unknown): string =>
  error instanceof Error ? error.message : 'Erro desconhecido';

export const fetchPendencias = createAsyncThunk<
  { conversaId: string; items: InternalChatPendencia[] },
  { conversaId: string },
  { rejectValue: string }
>('chatAtendimento/pendencias/fetch', async ({ conversaId }, { rejectWithValue }) => {
  try {
    const result = await pendenciasService.list({ conversaId });
    return { conversaId, items: result.items };
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});

export const createPendencia = createAsyncThunk<
  InternalChatPendencia,
  CreatePendenciaInput,
  { rejectValue: string }
>('chatAtendimento/pendencias/create', async (input, { rejectWithValue }) => {
  try {
    return await pendenciasService.create(input);
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});

export const updatePendencia = createAsyncThunk<
  InternalChatPendencia,
  {
    pendenciaId: string;
    nome?: string;
    descricao?: string;
    resolvida?: boolean;
    lembreteEm?: string | null;
    mensagemId?: string | null;
  },
  { rejectValue: string }
>('chatAtendimento/pendencias/update', async ({ pendenciaId, ...rest }, { rejectWithValue }) => {
  try {
    return await pendenciasService.update(pendenciaId, rest);
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});

export const deletePendencia = createAsyncThunk<
  { pendenciaId: string; conversaId: string },
  { pendenciaId: string; conversaId: string },
  { rejectValue: string }
>('chatAtendimento/pendencias/delete', async ({ pendenciaId, conversaId }, { rejectWithValue }) => {
  try {
    await pendenciasService.remove(pendenciaId);
    return { pendenciaId, conversaId };
  } catch (error) {
    return rejectWithValue(reject(error));
  }
});
